import React from "react";
var Isvg = require("../../../vendor/react-inlinesvg");
var Tooltip = require("./tooltip").Tooltip;
var TooltipMixin = require("./tooltip").TooltipMixin;
import Dispatcher from "../../dispatcher";

class ToolbarButton extends React.Component {
  constructor(props) {
    super(props);
    this.state = {};
    // Apply TooltipMixin
    this.showTooltip = TooltipMixin.showTooltip.bind(this);
    this.removeTooltip = TooltipMixin.removeTooltip.bind(this);
    this._addTooltipEvent = TooltipMixin._addTooltipEvent.bind(this);
    this._removeTooltipEvent = TooltipMixin._removeTooltipEvent.bind(this);
    this._light = this._light.bind(this);
    this._touchClickEvent = this._touchClickEvent.bind(this);
  }

  componentDidMount() {
    if (this.props.light) {
      Dispatcher.bind(Dispatcher.BOOK_PAGE_LOAD, this._light);
    }
  }

  componentWillUnmount() {
    Dispatcher.unbind(Dispatcher.BOOK_PAGE_LOAD, this._light);
  }

  _light() {
    if (this.props.light) {
      return this.props.light();
    }
  }

  _touchClickEvent(e) {
    e.stopPropagation();
    e.preventDefault();
    this.props.clickEvent(e);
  }

  render() {
    // remove "-button" from the id name to get the name of the svg to use
    var svgName = this.props.icon
      ? this.props.icon
      : this.props.id.slice(0, -7);
    var iconId = this.props.icon
      ? ` ${
          this.props.icon.indexOf("svg") > 0
            ? this.props.icon.match(/\/img\/*(.*)\.svg/).reverse()[0]
            : this.props.icon
        }`
      : "";
    let opacity = this._light() ? " halfOpacity" : " fullOpacity";
    return (
      <div>
        <button
          className={
            "toolbar-button " +
            this.props.id +
            (this.props.icon ? " " + this.props.icon : "") +
            (this.props.active ? ` active-${this.props.activeMethod}` : "") +
            opacity
          }
          id={this.props.id}
          data-tooltip={this.props.title}
          data-tooltip-location="right"
          data-target-dom-id={this.props.id}
          aria-pressed={!!this.props.active}
          onClick={this.props.clickEvent}
          onTouchEnd={this._touchClickEvent}
          onMouseEnter={this._addTooltipEvent}
          onMouseLeave={this._removeTooltipEvent}
        >
          <Isvg src={this.props.icon}>NS</Isvg>
          {this.props.notificationCount && (
            <span className="notification-dot">
              {this.props.notificationCount}
            </span>
          )}
          <span className="label">{window.toHTML(this.props.title)}</span>
        </button>
        <Tooltip tooltip={this.state.tooltip} />
      </div>
    );
  }
}

module.exports = ToolbarButton;
